//# sourceMappingURL=file.mjs.map
/// <reference types="./file.d.mts" />
import * as $svg from "../../ds/internals/svg.mjs";

export function file() {
  return $svg.square(
    14,
    "<path d=\"M12.25 4.6665V12.2458C12.2505 12.3224 12.236 12.3983 12.2072 12.4693C12.1783 12.5403 12.1358 12.6049 12.082 12.6594C12.0282 12.714 11.9642 12.7574 11.8937 12.7872C11.8231 12.817 11.7474 12.8326 11.6707 12.8332H2.32925C2.17572 12.8332 2.02848 12.7722 1.91986 12.6637C1.81125 12.5552 1.75015 12.408 1.75 12.2545V1.74517C1.75 1.43192 2.01192 1.1665 2.3345 1.1665H8.74825L12.25 4.6665ZM11.0833 5.24984H8.16667V2.33317H2.91667V11.6665H11.0833V5.24984ZM4.66667 4.08317H6.41667V5.24984H4.66667V4.08317ZM4.66667 6.4165H9.33333V7.58317H4.66667V6.4165ZM4.66667 8.74984H9.33333V9.9165H4.66667V8.74984Z\" fill=\"currentColor\"/>",
  );
}
